import { render, staticRenderFns } from "./OneCard.vue?vue&type=template&id=17afe01c&scoped=true&"
import script from "./OneCard.vue?vue&type=script&lang=js&"
export * from "./OneCard.vue?vue&type=script&lang=js&"
import style0 from "./OneCard.vue?vue&type=style&index=0&id=17afe01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afe01c",
  null
  
)

export default component.exports